
export const socials = {
	facebook: "https://web.facebook.com/profile.php?id=61578967744739",
};

export const address = {
	email: "issg.gestion@outlook.fr",
	phone: "+226 78 81 25 61 / +226 75 52 29 59",
};